module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAYAAAAvxDzwAAAAAXNSR0IArs4c6QAAAT1JREFUOE+t079L1VEcxvHXEwk2BdFiIG2N1T+QS3P/QDkFRhCEQ1AhRYmBTdUiSFOLg4P/gUNTQ0NDbc0ptDRkhCR+4sj3Xq72417Rsxw4fD7v8zyf55zoVlVdwzTO9c4OsX/BapK1tKaqeoyneIuP2DsfcRUu4QrmUlXn8RnzSRZGhPxRVlUP8aQBm9WVzmpTdgdvkmwMg1dVG891LOMENhrwBl5iAmfxHqfwqBUm2T0Irqp28U0s4icuYgubDdhueNUUJvlVVWfwDLfwDreTfBoI7wKWcBWvcT/Jt6oa6yncBxxonOoaJvEcL3AXD/AVM0nWB+r/D+zSb9bncA/bGO/G0wL8MTiKoQoPFF/GbBtNkg9/C+tQwGFpd276lvspJ9kZpfkfCk/2Uu6/wyTfjwA83Uv5eH/Kcf/l3/MvniVOsqcNAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/nav/Email.png
// module id = 4Ohy
// module chunks = 0